
export function isTouchDevice() {
    const hasTouch =
        navigator.maxTouchPoints > 0 ||
        window.matchMedia('(any-pointer: coarse)').matches;

    const hasFinePointer =
        window.matchMedia('(any-pointer: fine)').matches;

    // Echtes Touch-only Gerät: hat coarse pointer, aber keinen fine pointer (Maus).
    // Hybrid-Geräte (z.B. Surface mit Maus) haben beides → kein Touch-Modus.
    if (hasTouch && !hasFinePointer) {
        return true;
    }

    return false;
}